import { render, staticRenderFns } from "./SpinnerButton.vue?vue&type=template&id=b011cbc6&scoped=true"
import script from "./SpinnerButton.vue?vue&type=script&lang=js"
export * from "./SpinnerButton.vue?vue&type=script&lang=js"
import style0 from "./SpinnerButton.vue?vue&type=style&index=0&id=b011cbc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b011cbc6",
  null
  
)

export default component.exports